import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  InputAdornment,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import api from "../../../components/services/api";
import mime from "mime";
import { saveAs } from "file-saver";
import DowloadBT from "../../Planner/components/dowloadBT";
import { DesktopDatePicker, LocalizationProvider, PickersDay } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
// import { useSelector } from "react-redux";
import moment from "moment";

import SearchIcon from "@mui/icons-material/Search";
// import {
//   GridToolbarContainer,
//   GridToolbarExport,
//   gridClasses,
// } from "@mui/x-data-grid";
export default function WorkOrder() {
  // const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [key, setKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [toCountry, setToCountry] = useState("all");
  const [location, setLocation] = useState([]);
  const [locationFilter, setLocationFilter] = useState([]);
  const [country, setCountry] = useState([]);
  const [toAction, setToAction] = useState("all");
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  // const MenuActive = useSelector((state) => state.MenuActive.List);
  // function CustomToolbar() {
  //   return (
  //     <GridToolbarContainer className={gridClasses.toolbarContainer}>
  //       <GridToolbarExport
  //         style={{
  //           color: "#84BD5A",
  //           borderColor: "#84BD5A",
  //           border: "1px solid #84BD5A",
  //         }}
  //         printOptions={{ disableToolbarButton: true }}
  //         csvOptions={{
  //           fields: [
  //             "Status",
  //             "SoNumber",
  //             "CustomerName",
  //             "EtdPol",
  //             "EtdCloseingDate",
  //             "ShippingBookingNo",
  //             "PickupVoyageNo",
  //           ],
  //           fileName: "PlanningData " + new Date() + Math.random(),
  //         }}
  //       />
  //     </GridToolbarContainer>
  //   );
  // }

  const formatDate = (value) =>
    value ? moment(value).format("YYYY-MM-DD") : "";

  /* table data */
  const columns = [
    {
      field: "ContainerManagementStatus",
      headerName: "Status",
      width: 150,
    },
    { field: "WorkOrderNo", headerName: "Work Order No.", width: 180 },
    { field: "SaleOrderNo", headerName: "Sale Order No.", width: 180 },
    { field: "Quantity", headerName: "Volume", width: 100 },
    { field: "ShipperRefNo", headerName: "Shipper Ref No.", width: 180 },
    { field: "BookingNo", headerName: "Booking No.", width: 180 },
    {
      field: "PickupDate",
      headerName: "Pick up Date",
      width: 130,
      valueFormatter: ({ value }) => formatDate(value),
    },
    {
      field: "StuffingDate",
      headerName: "Stuffing Date",
      width: 130,
      valueFormatter: ({ value }) => formatDate(value),
    },
    {
      field: "ClosingDate",
      headerName: "Closing Date",
      width: 130,
      valueFormatter: ({ value }) => formatDate(value),
    },
    {
      field: "ETDPOLDate",
      headerName: "ETD POL",
      width: 130,
      valueFormatter: ({ value }) => formatDate(value),
    },
    {
      field: "Action",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/Truck/EditWorkOrder/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                view
              </Button>
            </Link>
          </>
        );
      },
    },
  ];

  //fetch Data
  const getData = async () => {
    try {
      const data = await api.get(`api/workorder/list`);
      //   console.log(data);
      // setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const searchList = async () => {
    try {
      const data = await api.get(
        `api/workorder/list?keyword=${key}&startDate=${dateStart || ""}&edate=${
          dateEnd || ""
        }${dateEnd ? "&endDate=" + dateEnd : ""}${
          toCountry === "all" ? "" : "&countryId=" + toCountry
        }${toAction === "all" ? "" : "&locationId=" + toAction}`
      );
      //   console.log(data);
      // setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getCountry = async () => {
    try {
      const res = await api.get("api/country/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCountry(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocation(data.filter((x) => x?.Status === true));
        setLocationFilter(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  //api call

  useEffect(() => {
    getLocation();
    getCountry();
    getData();
  }, []);
  useEffect(() => {
    if (toCountry !== "all") {
      const filterLocation = location?.filter(
        (item) => item.CountryId === toCountry
      );
      setLocationFilter(filterLocation);
      setToAction(filterLocation[0]?.LocationId);
    } else {
      setLocationFilter(location);
    }
  }, [toCountry]);
  //Floating Button
  // const floating_action_style = {
  //   margin: 0,
  //   top: "auto",
  //   right: 20,
  //   bottom: 10,
  //   left: "auto",
  //   position: "fixed",
  // };
  const handleDownload = async () => {
    setLoading(true);
    await api
      .get(`api/report/workorder-list/download?keyword=${key}`, {
        responseType: "blob",
        timeout: 30000,
      })
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.xlsx", {
          type: mime.getType(".xlsx"),
        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, "Report.xlsx");
        setLoading(false);
      });
  };
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ใบสั่งงาน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Work Order
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Truck</Typography>
            <Typography>
              <span>&nbsp;</span> / Work Order
            </Typography>
          </Grid>
        </Grid>

        <Grid
          style={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <DowloadBT onClick={handleDownload} loading={loading} />
          <FormControl
            size="small"
            sx={{
              width: "350px",
              marginRight: "10px",
            }}
          >
            <InputLabel>Country</InputLabel>
            <Select
              label="Country"
              value={toCountry}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToCountry(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {country?.map((x) => (
                <MenuItem value={x?.CountryId}>{x?.CountryName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{
              width: "350px",
              marginRight: "10px",
            }}
          >
            <InputLabel>Location</InputLabel>
            <Select
              label="Location"
              value={toAction}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToAction(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {locationFilter?.map((x) => (
                <MenuItem value={x?.LocationId}>{x?.LocationName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Date Start"
              value={dateStart}
              inputFormat="yyyy/MM/dd"
              minDate={new Date("2017-01-01")}
              onChange={(newValue) => {
                setDateStart(moment(newValue).format("yyyy-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  style={{ width: "350px", marginLeft: "10px" }}
                  {...params}
                />
              )}
            />
            <DesktopDatePicker
              label="Date End"
              value={dateEnd}
              inputFormat="yyyy/MM/dd"
              minDate={new Date(dateStart)}
              onChange={(newValue) => {
                setDateEnd(moment(newValue).format("yyyy-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  style={{
                    width: "350px",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              disableUnderline: true,
            }}
            style={{
              width: "300px",
            }}
            label="Search"
            onChange={(e) => setKey(e.target.value)}
            size="small"
          />
          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px",
              width: "200px",
            }}
            onClick={() => searchList()}
          >
            <SearchIcon />
          </Button>
        </Grid>

        <Box
          sx={{
            height: 650,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.WorkOrderId}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value === 1 ? "Active" : "Inactive";
              }
            }}
            // components={{
            //   Toolbar: CustomToolbar,
            // }}
          />
        </Box>
      </Card>
      {/* {MenuActive.find((x) => x.ActionNo === "A033") && (
        <Link to="/Truck/AddWorkOrder">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )} */}
    </div>
  );
}
